import _ from 'lodash'
import Backbone from 'backbone'
import template from './form-action-editor.hbs'
import dropdown from 'scoreboard/components/dropdown'
import formHelper from 'scoreboard/components/form-helper'
import enums from 'scoreboard/components/enums'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import selects from 'scoreboard/components/selects'
import FormActionType from 'scoreboard/forms/model/form-action-type'
const {
	SAVE_RECORD, NEW_RECORD, GO_TO_PAGE, CHANGE_WIDGET_STATE,
	CHANGE_WIDGET_VALIDATION, SET_FIELD_VALUE, SEND_ALERT
} = FormActionType
import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
const { FIELD } = FormWidgetType
import widgetOptions from 'scoreboard/forms/widgets/widget-options'
import unwrapModel from 'scoreboard/components/unwrap-model'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'
import renderFieldDropdown from '../../datasets/render-field-dropdown'
import constants from 'scoreboard/components/constants'
import FieldValueControl from '../../datasets/records/field-value-control'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, TEXT, DATE, TIME, DATE_TIME, CURRENCY, PERCENT } = DataType

import FormWidgetInputValidationType
	from 'scoreboard/forms/model/form-widget-input-validation-type'
const {
    INPUT_REQUIRED,
    INPUT_OPTIONAL,
    MINIMUM_LENGTH,
    MAXIMUM_LENGTH,
    MINIMUM_MAXIMUM_LENGTH,
    CUSTOM_EXPRESSION,
} = FormWidgetInputValidationType

import { renderInputValidationFields } from './widget-utils'
import EditableButton from 'scoreboard/components/editable-button'
import AlertDetails from './alert-details'
import appDisplay from 'scoreboard/components/app-display'
import widgetMetadata from './widget-metadata'
import formType from '../model/form-type'
import {getDialogDatasetOrDataset} from '../edit/pages-edit'

const {
	SPECIFIC_VALUE,
	BLANK,
	CURRENT_DATE_TIME,
	USER_EMAIL,
	USER_NAME,
	USER_USERNAME,
	USER_ID,
	USER_IP_ADDRESS
} = constants.SET_FIELD_VALUE_TYPE
const {
	CALCULATED,
	CLUSTER,
} = constants.DATASET_FIELD_TYPE
const allowedWidgetValidationTypes = {
	[INPUT_OPTIONAL]: [],
	[INPUT_REQUIRED]: [],
	[MINIMUM_LENGTH]: [NUMBER, CURRENCY, PERCENT, TEXT],
	[MAXIMUM_LENGTH]: [NUMBER, CURRENCY, PERCENT, TEXT],
	[MINIMUM_MAXIMUM_LENGTH]: [NUMBER, CURRENCY, PERCENT, TEXT],
	[CUSTOM_EXPRESSION]: [NUMBER, CURRENCY, PERCENT, TEXT]
}
const allowedSetFieldValueTypes =  {
	[SPECIFIC_VALUE]: [], // Empty array means all types are allowed
	[BLANK]: [],
	[CURRENT_DATE_TIME]: [TEXT, DATE, TIME, DATE_TIME],
	[USER_EMAIL]: [TEXT],
	[USER_NAME]: [TEXT],
	[USER_USERNAME]: [TEXT],
	[USER_ID]: [NUMBER, TEXT],
	[USER_IP_ADDRESS]: [TEXT]
}
const FormActionEditor = Backbone.View.extend({

	tagName: 'li',

	className: 'form-action-editor item',

	/**
	 *
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Form} options.model
	 *
	 * @param {FormAction} options.action the metadata for the action to be rendered
	 *
	 * @param {String[]} [options.allowedActionTypes] the action types which
	 * are allowed. If omitted, all action types are allowed
	 *
	 * @param {Widget} [options.currentWidget] the current widget containing this
	 * form action editor
	 */
	initialize: function(options = {}) {
		this.options = options
		this.dataset = getDialogDatasetOrDataset(this.model)
		// #56631 - Store the view in the DOM element to allow using getData()
		// when form-actions-editor.js readFromDom is called
		this.$el.data('view', this)

		// #56468
		// Store the field value in a local variable to avoid overwriting
		// initial values when the view is not saved
		this.setFieldValue = this.options.action?.setFieldValue
		// 54608 - store alert details in local variables
		this.alertMessage = this.options.action?.alertMessage
		this.alertRecipients = this.options.action?.alertRecipients
		this.alertUserIds = this.options.action?.alertUserIds
		this.alertGroupIds = this.options.action?.alertGroupIds
		this.alertPopup = this.options.action?.alertPopup
	},

	events: {
		'change [name=type]': 'onChangeType',
		'change [name=setFieldValueType]': 'onChangeSetFieldValueType',
		'change [name=setFieldValueFieldId]': 'onChangeSetFieldValueFieldId',
		'change [name=changeWidgetId]': 'onChangeWidgetId',
		'change [name=changeWidgetValidation]': 'onChangeWidgetValidationSelect',
		'click .set-alert': 'onClickSetAlert'
	},

	render: function() {
		this.$el
			.html(template())
			.data('id', _.get(this.options, 'action.id'))
		this.renderTypeDropdown()

		this.renderGoToPageFormIdSelect()
		this.renderChangeWidgetIdSelect()
		this.renderSetAlertButton()

		// write either the actual or temporary id to dom
		const data = _.cloneDeep(this.options.action) || {}
		if (!data.changeWidgetId && !!data.changeWidgetTempId) {
			data.changeWidgetId = data.changeWidgetTempId
		}
		formHelper.writeToDom(data, this.el)

		// important that this is after writeToDom as it uses existing values
		this.renderChangeWidgetStateSelect()
		this.renderChangeWidgetValidationSelect()

		this.renderSetFieldValueTypeSelect()
		this.renderSetFieldValueFieldIdDropdown()

		renderInputValidationFields.bind(this)()

		// make sure the appropriate controls are displayed for the action type
		this.onChangeType()
		this.onChangeSetFieldValueType()
		this.onChangeWidgetValidationSelect()
		return this
	},

	renderTypeDropdown: function() {
		dropdown.object(this.$('[name=type]'), this.getTypeDropdownOptions())
	},

	getTypeDropdownOptions: function() {
		let options = enums.formActionType
		const { type } = this.model.attributes
		const { allowedActionTypes } = this.options

		// Filter the options based on the type (e.g., DIALOG)
		let filteredOptions = Object.fromEntries(
			Object.entries(options).filter(([key]) => {
				// If the type is DIALOG, filter out specific keys
				if (type === formType.DIALOG) {
					return ![SAVE_RECORD, NEW_RECORD, GO_TO_PAGE].includes(key)
				}
				return true
			})
		)

		// If allowedActionTypes is empty, return filtered options
		if (_.isEmpty(allowedActionTypes)) {
			return filteredOptions
		}

		// If allowedActionTypes is not empty, return options that match the allowedActionTypes
		return _.pick(filteredOptions, allowedActionTypes)
	},

	renderGoToPageFormIdSelect: function() {
		const model = unwrapModel(this.model)
		let el = this.$('[name=goToPageFormId]')

		let pageOrderMap = _.reduce(this.options.pageOrder, (acc, id, index) => {
			acc[id] = index
			return acc
		}, {})

		let pages = _.chain(model.pages)
			// #59202
			// Dialogs are not meant to act as individual pages to navigate to
			.filter(page => page.type !== formType.DIALOG)
			.sortBy(item => pageOrderMap[item.id])
			.value()

		// #53612 filter out the current page so infinite loops can't be created
		pages = _.filter(pages, p => p.id != model.id)

		// #54625 use the qualifiedLabel to distinguish pages with the same name
		// that are part of different navigation tabs
		pages = _.map(pages, p => ({ id: p.id, label: p.qualifiedLabel }))

		dropdown.idLabels(el, pages)
		this.goToPageFormIdMarkedField = new MarkedField({
			el,
			// this is currently incorrectly triggering when it's hidden
			validator: requiredValidator
		}).render()
	},

	renderChangeWidgetIdSelect: function() {
		const model = unwrapModel(this.model)
		let el = this.$('[name=changeWidgetId]')

		// update the options with the button label field
		const widgets = _.cloneDeep(model.widgets)

		// keep up to date with changes made in the ui
		const buttonLabel = $('[name=buttonLabel]').val()
		const widget = this.options?.currentWidget || {}
		const { id, tempId } = widget
		if (!_.isNil(buttonLabel) && (!_.isNil(id) || !_.isNil(tempId))) {
			const option = _.find(widgets, w =>
				(!!id && w.id === id) || (!!tempId && w.tempId === tempId))
			if (!!option) option.buttonLabel = buttonLabel
		}

		const value = el.val()
		let isChangeValidation =
			this.$('[name=type]').val() === CHANGE_WIDGET_VALIDATION
		selects.filtering(el, {
			options: widgetOptions(widgets,
				isChangeValidation ? { type: FIELD } : {}, this),
			sort: []
		})

		// if we are updating the options and there is a value present, keep it
		if (value) selects.val(el, value)

		if (!!this.changeWidgetIdMarkedField) return
		this.changeWidgetIdMarkedField = new MarkedField({
			el,
			validator: requiredValidator
		}).render()
	},

	renderChangeWidgetSelect: function(type) {
		if (type == CHANGE_WIDGET_STATE) {
			this.renderChangeWidgetStateSelect()
		}

		if (type == CHANGE_WIDGET_VALIDATION) {
			this.renderChangeWidgetValidationSelect()
		}
	},

	onChangeWidgetId: function() {
		let type = this.$('[name=type]').val()
		this.renderChangeWidgetSelect(type)
	},

	renderChangeWidgetStateSelect: function() {
		const widgetsById = this.model.widgetsById
		const model = unwrapModel(this.model)
		let el = this.$('[name=changeWidgetState]')

		const initialVal = el.val()
		const widgetId = this.$('[name=changeWidgetId]').val()
		const widget = widgetsById[widgetId] ||
			_.find(model.widgets, w => w.tempId === widgetId)

		const allowedTypes = widgetMetadata.states[widget?.type]
		const options = _.isNil(allowedTypes) ? [] :
			_(enums.toOptionData('widgetState'))
				.filter(o => _.includes(allowedTypes, o.id))
				.map(o => ({ label: o.label, value: o.id }))
				.value()

		selects(el, { options })
		const selected = initialVal || this.options.action?.changeWidgetState
		const isValidOption = _.some(options, o => o.value === selected)
		if (isValidOption) selects.val(el, selected)

		if (!!this.changeWidgetStateMarkedField) {
			this.changeWidgetStateMarkedField.clearError()
			return
		}
		this.changeWidgetStateMarkedField = new MarkedField({
			el,
			validator: requiredValidator
		}).render()
	},

	renderChangeWidgetValidationSelect: function() {
		let el = this.$('[name=changeWidgetValidation]')
		const initialVal = el.val()
		let widgetId = this.$('[name=changeWidgetId]').val()
		let widget = this.model.widgetsById[widgetId]
		let field = this.dataset.combinedFieldsById[widget?.fieldId]
		let fieldDataType = this.dataset.getUnderlyingField(field)?.dataType

		const options = _.map([
			INPUT_OPTIONAL,
			INPUT_REQUIRED,
			MINIMUM_LENGTH,
			MAXIMUM_LENGTH,
			MINIMUM_MAXIMUM_LENGTH,
			CUSTOM_EXPRESSION
		], o =>
			({ value: o, label: i18n.get(`forms.widgets.inputValidation.${o}`) }))
		let filteredOptions = _.filter(options, o => {
			let allowedFieldDataTypes = allowedWidgetValidationTypes[o.value]
			return _.isEmpty(allowedFieldDataTypes) ||
				_.includes(allowedFieldDataTypes, fieldDataType)
		})
		selects(el, { options: filteredOptions })

		// Check if the initial value is allowed and, if not, set the selected value to `input-optional`
		// If the initial value is null, set the selected value to the saved action value
		const isAllowedVal = _.some(filteredOptions, { value: initialVal })
		const selectedVal = isAllowedVal ? initialVal : INPUT_OPTIONAL
		const selected = initialVal === null ? this.options.action?.changeWidgetValidation : selectedVal
		if (!!selected) selects.val(el, selected)

		// Hide the validation fields if the selected value is not allowed
		if (!isAllowedVal) {
			this.onChangeWidgetValidationSelect()
		}

		if (!!this.changeWidgetStateMarkedField) {
			this.changeWidgetStateMarkedField.clearError()
			return
		}
		this.changeWidgetStateMarkedField = new MarkedField({
			el,
			validator: requiredValidator
		}).render()
	},

	onChangeWidgetValidationSelect: function() {
		let type = this.$('[name=changeWidgetValidation]').val()
		this.$('.minimum-length')
			.toggleClass('is-not-displayed', !_.includes([MINIMUM_LENGTH, MINIMUM_MAXIMUM_LENGTH], type))
		this.$('.maximum-length')
			.toggleClass('is-not-displayed', !_.includes([MAXIMUM_LENGTH, MINIMUM_MAXIMUM_LENGTH], type))
		this.$('.custom-expression')
			.toggleClass('is-not-displayed', type != CUSTOM_EXPRESSION)

		this.minimumLengthMarkedField?.clearError?.()
		this.maximumLengthMarkedField?.clearError?.()
		this.customExpressionMarkedField?.clearError?.()
	},

	renderSetFieldValueTypeSelect: function(changeId) {
		let el = this.$('[name=setFieldValueType]')
		let fieldId = changeId ?? this.options.action?.setFieldValueFieldId
		let field = this.dataset.combinedFieldsById[fieldId]
		let fieldDataType = this.dataset.getUnderlyingField(field)?.dataType
		let savedType = this.options.action?.setFieldValueType // populated when editing an existing action
		let dateTimeFieldDataType = fieldDataType === DATE || fieldDataType === TIME ? fieldDataType : DATE_TIME

		const options = [
			{
				value: SPECIFIC_VALUE,
				label: i18n.get('forms.actions.action.set-field-value-type.specific-value')
			},
			{
				value: BLANK,
				label: i18n.get('forms.actions.action.set-field-value-type.blank')
			},
			{
				value: CURRENT_DATE_TIME,
				label: i18n.get(`forms.actions.action.set-field-value-type.current-${dateTimeFieldDataType}`)
			},
			{
				value: USER_EMAIL,
				label: i18n.get('forms.actions.action.set-field-value-type.user-email')
			},
			{
				value: USER_NAME,
				label: i18n.get('forms.actions.action.set-field-value-type.user-name')
			},
			{
				value: USER_USERNAME,
				label: i18n.get('forms.actions.action.set-field-value-type.user-username')
			},
			{
				value: USER_ID,
				label: i18n.get('forms.actions.action.set-field-value-type.user-id')
			},
			{
				value: USER_IP_ADDRESS,
				label: i18n.get('forms.actions.action.set-field-value-type.user-ip-address')
			}
		]
		let filteredOptions = _.filter(options, o => {
			let allowedFieldDataTypes = allowedSetFieldValueTypes[o.value]
			return _.isEmpty(allowedFieldDataTypes) ||
				_.includes(allowedFieldDataTypes, fieldDataType)
		})

		// Ensure the saved type is allowed and, if not, set the selected value to `specific-value`
		const isAllowedVal = _.some(filteredOptions, { value: savedType })
		const selected = isAllowedVal ? savedType : SPECIFIC_VALUE
		selects(el, { options: filteredOptions })
		if (!!selected) selects.val(el, selected)
		if (!this.setFieldValueTypeMarkedField) {
			this.setFieldValueTypeMarkedField = new MarkedField({
				el,
				// this is currently incorrectly triggering when it's hidden
				validator: requiredValidator,
			}).render()
		}
	},

	renderSetFieldValueFieldIdDropdown: function() {
		// Do not allow calculated or cluster field types
		let allowedFieldIds = []
		const unwrappedModel = unwrapModel(this.model)
		const widgets = unwrappedModel?.widgets
		// #56966 only use list of field ids from widgets on current form
		const formWidgetFieldIds = getWidgetFieldIds(widgets)
		const manuallyAddedFieldId = this.dataset?.get?.('manuallyAddedFieldId')

		formWidgetFieldIds?.forEach(fieldId => {
			const field = this.dataset?.combinedFieldsById?.[fieldId]
			// Ensure that we do not add the 'Record Manually Added' field to the dropdown
			const isManuallyAddedField = fieldId == manuallyAddedFieldId
			const isCurrentField =
				this.options.currentWidget?.fieldId == fieldId
			const fieldType = field.fieldType
			if (fieldType != CALCULATED
				&& fieldType != CLUSTER
				&& !isManuallyAddedField
				&& !isCurrentField
			) {
				allowedFieldIds.push(field.id)
			}
		})
		this.setFieldValueFieldIdMarkedField = renderFieldDropdown({
			el: this.$('[name=setFieldValueFieldId]'),
			dataset: this.dataset,
			required: true,
			allowedVisibleLinkedFieldIds: [],
			allowedFieldIds: allowedFieldIds,
			selectedId: this.options.action?.setFieldValueFieldId
		})
	},

	onChangeSetFieldValueType: function() {
		let type = this.$('[name=setFieldValueType]').val()
		this.$('.set-field-value-specific-value').toggleClass('is-not-displayed',
			type != SPECIFIC_VALUE)
		// Re-render the field value control if the type is specific value
		if (type === SPECIFIC_VALUE) {
			this.renderSetFieldValueSpecificValue()
		}

		this.specificValueControl?.clearError?.()
	},

	onChangeSetFieldValueFieldId: function() {
		// renderSetFieldValueTypeSelect with options that match field type
		this.renderSetFieldValueTypeSelect(this.$('[name=setFieldValueFieldId]').val())

		// capture the type after calling renderSetFieldValueTypeSelect which re-renders
		// the dropdown for choosing specific value, username, user email, etc.
		// This is done in case the current Field Value Type is no longer
		// allowed (ex. User ID is selected, but we switch to a date field)
		let type = this.$('[name=setFieldValueType]').val()
		this.$('.set-field-value-specific-value').toggleClass('is-not-displayed',
			type != SPECIFIC_VALUE)

		// Prevent rendering the field value control in the background
		if (type === SPECIFIC_VALUE) {
			// #56468
			// Reset field value in case we change to an incompatible field type
			this.setFieldValue = null

			this.renderSetFieldValueSpecificValue(false)
		}
	},

	renderSetFieldValueSpecificValue: function(isSameField = true) {
		this.specificValueControl?.remove?.()
		let fieldValueFieldId = this.$('[name=setFieldValueFieldId]').val()
		let type = this.$('[name=setFieldValueType]').val()
		let label = _.get(this.dataset, `combinedFieldsById.${fieldValueFieldId}.label`)
		let value = (type === SPECIFIC_VALUE && isSameField) ?
			this.setFieldValue : null

		if (fieldValueFieldId) {
			this.specificValueControl = new FieldValueControl({
				fieldId: fieldValueFieldId,
				model: this.dataset,
				label: label,
				required: true,
				formView: this.options.formView,
				value: value,
				treeItemsById: this.model.treeItemsById,
				allowYesNoBlankOption: false,
			})
			this.$('.set-field-value-specific-value')
				.append(this.specificValueControl.el)

			// #56468
			// Keep the field value in sync with the control
			this.listenTo(this.specificValueControl, 'change', () => {
				const result = formHelper
					.readFromDom(this.specificValueControl.el)
				this.setFieldValue = result?.[fieldValueFieldId]
			})
			this.specificValueControl.render()
		}
	},

	renderSetAlertButton: function() {
		this.setAlertButton = new EditableButton({
			el: this.$('.set-alert'),
			message: 'forms.actions.action.send-alert.alertDetails'
		}).render()
	},

	/**
	 * Renders the alert details dialog for "Send Alert" form actions
	 */
	onClickSetAlert: function() {
		this.alertDetails = new AlertDetails({
			message: this.alertMessage ?? '',
			recipients: this.alertRecipients ?? [],
			userIds: this.alertUserIds ?? [],
			groupIds: this.alertGroupIds ?? [],
			popup: this.alertPopup ?? false
		})
		this.alertDetails.on('done', details => {
			this.options.formView.change()
			this.alertMessage = details.message
			this.alertRecipients = details.recipients
			this.alertUserIds = details.userIds
			this.alertGroupIds = details.groupIds
			this.alertPopup = details.popup
		})
		appDisplay.dialog(this.alertDetails)
	},

	onChangeType: function() {
		let type = this.$('[name=type]').val()
		this.$('.go-to-page-form-id').toggleClass('is-not-displayed',
			type != GO_TO_PAGE)
		this.$('.change-widget-id').toggleClass('is-not-displayed',
			!_.includes([CHANGE_WIDGET_STATE, CHANGE_WIDGET_VALIDATION], type))
		this.$('.change-widget-state').toggleClass('is-not-displayed',
			type != CHANGE_WIDGET_STATE)
		this.$('.change-widget-validation, .input-validation-fields').toggleClass('is-not-displayed',
			type != CHANGE_WIDGET_VALIDATION)
		this.$('.set-field-value, .set-field-value-field-id, .set-field-value-specific-value')
			.toggleClass('is-not-displayed', type != SET_FIELD_VALUE)
		this.$('.send-alert').toggleClass('is-not-displayed', type != SEND_ALERT)

		this.updateFormActionEditorClass()
		this.renderChangeWidgetIdSelect()
		this.renderSetFieldValueFieldIdDropdown()

		// #56269
		// Re-render widget state or validation selects in case we are switching
		// between the two and want the state or validation options to
		// refresh correctly
		this.renderChangeWidgetSelect(type)

		_.invokeMap([this.goToPageFormIdMarkedField,
			this.changeWidgetIdMarkedField,
			this.changeWidgetStateMarkedField,
			this.setFieldValueTypeMarkedField,
			this.setFieldValueFieldIdMarkedField,
			this.minimumLengthMarkedField,
			this.maximumLengthMarkedField,
			this.customExpressionMarkedField], 'clearError')
	},

	/**
	 * Updates the class of the form action editor to match the selected type.
	 *
 	 * The previous type's class, if it exists, will be removed, and the newly
 	 * selected type will be added as a class. Additionally, the selected type
 	 * will be stored as a data attribute for future reference.
	 */
	updateFormActionEditorClass: function() {
		const prevType = this.$el.data('selected-type')
		if (prevType) {
			this.$el.removeClass(prevType)
		}

		const selectedType = this.$('[name=type]').val()
		this.$el.addClass(selectedType)
		this.$el.data('selected-type', selectedType)
	},

	getData: function() {
		let data = formHelper.readFromDom(this.el)
		let type = this.$('[name=type]').val()
		const alertProperties = [
			'alertMessage',
			'alertRecipients',
			'alertUserIds',
			'alertGroupIds',
			'alertPopup'
		]

		if (type == SEND_ALERT) {
			_.forEach(alertProperties, (prop) => {
				_.set(data, prop, this[prop])
			})
		} else {
			data = _.omit(data, alertProperties)
		}

		return data
	},

	autoRemove: true

})

/**
 * Returns all the field ids from a list of widgets
 * @param widgets - list of widgets to retrieve field ids from
 * @returns {*} - list of field ids tied to the widgets
 */
function getWidgetFieldIds(widgets) {
	return widgets.reduce((fieldIds, widget) => {
		if (widget?.fieldId) {
			fieldIds.push(widget?.fieldId)
		}
		if (Array.isArray(widget?.childWidgets)
			&& widget?.childWidgets?.length > 0
		) {
			fieldIds.push(...getWidgetFieldIds(widget?.childWidgets))
		}
		return fieldIds
	}, [])
}

export default FormActionEditor
export { getWidgetFieldIds }

FormActionEditor.__filename__ = 'forms/widgets/form-action-editor.js'
